import React from "react";
import { useTranslation } from "react-i18next";

const mockAnnouncements = [
  {
    id: 1,
    title: "Parent-Teacher Conferences Next Week",
    content:
      "Please sign up for a time slot with your student's teachers. The sign-up sheet is available on the school portal.",
    date: "2025-10-15",
  },
  {
    id: 2,
    title: "Annual Science Fair - Call for Projects",
    content:
      "The annual science fair is scheduled for November 20th. All students are encouraged to participate. Project proposals are due by October 31st.",
    date: "2025-10-12",
  },
  {
    id: 3,
    title: "Library Renovation Update",
    content:
      "The new library wing is now open! Come and check out our new collection of e-books and digital resources.",
    date: "2025-10-10",
  },
];

const Announcements = () => {
  const { t } = useTranslation();

  return (
    <div className="p-6 sm:p-8 lg:p-10 bg-gray-50 min-h-screen space-y-8">
      {/* --- Header --- */}
      <h2 className="text-2xl font-bold text-gray-800">
        {t("announcements.title")}
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* --- Create Announcement Form --- */}
        <div className="lg:col-span-1 bg-white p-6 sm:p-8 rounded-2xl shadow-sm h-fit space-y-4">
          <h3 className="text-xl font-bold text-gray-800">
            {t("announcements.createTitle")}
          </h3>

          <div className="space-y-4">
            <div>
              <label
                htmlFor="title"
                className="block text-sm font-medium text-gray-700"
              >
                {t("announcements.form.titleLabel")}
              </label>
              <input
                type="text"
                id="title"
                placeholder={t("announcements.form.titlePlaceholder")}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>

            <div>
              <label
                htmlFor="content"
                className="block text-sm font-medium text-gray-700"
              >
                {t("announcements.form.contentLabel")}
              </label>
              <textarea
                id="content"
                rows="4"
                placeholder={t("announcements.form.contentPlaceholder")}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>

            <button className="w-full bg-indigo-600 text-white font-semibold py-2 px-4 rounded-md hover:bg-indigo-700 transition">
              {t("announcements.form.postButton")}
            </button>
          </div>
        </div>

        {/* --- Announcement List --- */}
        <div className="lg:col-span-2 space-y-4">
          {mockAnnouncements.map((ann) => (
            <div
              key={ann.id}
              className="bg-white p-5 sm:p-6 rounded-2xl shadow-sm"
            >
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="font-bold text-lg text-gray-800">
                    {ann.title}
                  </h4>
                  <p className="text-sm text-gray-500">
                    {new Date(ann.date).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>

                <div className="flex space-x-2">
                  <button className="text-sm text-indigo-600 hover:underline">
                    {t("announcements.actions.edit")}
                  </button>
                  <button className="text-sm text-red-600 hover:underline">
                    {t("announcements.actions.delete")}
                  </button>
                </div>
              </div>

              <p className="mt-2 text-gray-700">{ann.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Announcements;
